// extracted by mini-css-extract-plugin
export default {"iban":"IBAN_iban__89Lwa","input":"IBAN_input__i8Bj5","success":"IBAN_success__svura","error":"IBAN_error__eEVyH","natural":"IBAN_natural__PLMJz","label":"IBAN_label__NQWcc"};